const EventEmitter = require('events');

import {newReq} from "@/core/request";

export class Device extends EventEmitter {
    constructor(obj) {
        super();
        this.hwId = null;
        this.name = null;
        this.username = null;
        this.hostname = null;
        this.siteId = null;
        this.hwInfo = null;
        this.disabled = false;
        this.employeeId = null;
        Object.assign(this, obj)
    }

    get ramGb() {
        try {
            return this.hwInfo.mem.total ? (this.hwInfo.mem.total / 1024 / 1024 / 1024).toFixed(1) : null
        } catch (e) {
            return null
        }
    }

    get hardwareDescription() {

        return this.hwInfo ? (this.hwInfo.cpu ? `${this.hwInfo.cpu.cores ? `${this.hwInfo.cpu.cores} Core ` : ''}${this.hwInfo.cpu.brand ? `${this.hwInfo.cpu.brand} ` : ''} - ${this.ramGb}GB Ram` : (this.hwInfo.systemInformation && this.hwInfo.systemInformation.Model ? this.hwInfo.systemInformation.Model : '-') ) : '-'
    }

    update(...keys) {
        const updateObj = JSON.parse(JSON.stringify(this))
        Object.keys(this).forEach(key => {
            if (!(keys || []).includes(key))
                delete updateObj[key];
        })
        return newReq('POST', `devices/update`, {...updateObj, _id: this._id})
    }
}